/* eslint-disable @typescript-eslint/no-explicit-any */
import { Grid } from "@mui/material";
import { TextValidator } from "react-material-ui-form-validator";
import { Vocabulary } from "../../Utils/Vocabulary";
import { useEffect, useState } from "react";
import { ContactPerson, CustomerModel } from "../../Utils/Models";

type ContactPersonProps = {
  customer: CustomerModel;
  index: number;
  handleChangeCustomer: (product: CustomerModel) => void;
};
export default function Contact(props: ContactPersonProps) {
  const { customer, index, handleChangeCustomer } = props;
  const customerLocation = customer.locations?.[index];
  const [contact, setContact] = useState(new ContactPerson());

  /**
   *
   */
  useEffect(() => {
    if (customer && customerLocation) {
      setContact(customerLocation.contactPerson);
    } else {
      setContact(new ContactPerson());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customer, customerLocation]);

  useEffect(() => {
    if (contact && customerLocation) {
      customerLocation.contactPerson = contact;
      handleChangeCustomer(customer);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [contact]);

  return (
    <Grid container spacing={2} style={{ marginTop: 10 }}>
      <Grid item xs={12} sm={12} md={6} lg={6}>
        <TextValidator
          size="small"
          id="firstName"
          name="firstName"
          label={Vocabulary.firstName}
          fullWidth
          variant="outlined"
          value={contact.firstName}
          onChange={(event: any) => {
            setContact({ ...contact, firstName: event.target.value });
          }}
        />
      </Grid>
      <Grid item xs={12} sm={12} md={6} lg={6}>
        <TextValidator
          size="small"
          id="lastName"
          name="lastName"
          label={Vocabulary.lastName}
          fullWidth
          variant="outlined"
          value={contact.lastName}
          onChange={(event: any) => {
            setContact({ ...contact, lastName: event.target.value });
          }}
        />
      </Grid>
      <Grid item xs={12} sm={12} md={6} lg={6}>
        <TextValidator
          size="small"
          id="email"
          name="email"
          label={Vocabulary.email}
          fullWidth
          variant="outlined"
          value={contact.email}
          onChange={(event: any) => {
            setContact({ ...contact, email: event.target.value });
          }}
        />
      </Grid>
      <Grid item xs={12} sm={12} md={6} lg={6}>
        <TextValidator
          size="small"
          id="phone"
          name="phone"
          label={Vocabulary.phone}
          fullWidth
          variant="outlined"
          value={contact.phone}
          onChange={(event: any) => {
            setContact({ ...contact, phone: event.target.value });
          }}
        />
      </Grid>
    </Grid>
  );
}
